<ng-container>
  <div class="ppl-container-body">
    <div class="ppl-container-head">
      <div class="details-header">
        <ppl-button label="Back" icon="fa fa-chevron-left" [customClass]="'ghost-button'" iconPosition="left"
          (click)="goBack()">
        </ppl-button>
        <h1 class="page-title-accessibility">
          Payroll Batch Results@if (batchInstanceId) { <span> — Batch {{ batchInstanceId }}</span> }
        </h1>
      </div>
    </div>
    <div class="ppl-container">
      <div class="ppl-content-container">
        <div class="table-style">
          <ppl-list-table
            [data]="results"
            [cols]="cols"
            [customDataLoaded]="true"
            [customDataHasUnknownTotal]="true"
            [pagination]="true"
            [loadPage]="true"
            [recordsPerPage]="recordsPerPage"
            [tableWidth]="'100%'"
            [tableScrollable]="true"
            tableScrollHeight="flex"
            [gridTitle]="false"
            [disableSort]="true"
            [disableSearch]="true"
            [enableActions]="false"
            [enablePageActions]="true"
            (onPageLoad)="onPageLoad($event)"
            (actionInvoked)="onListAction($event)">
          </ppl-list-table>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ppl-popup-dialog
  [(isVisible)]="showExcludeDialog"
  title="Exclude Batch Rows"
  [showClose]="true"
  [showButtons]="true"
  [showOkButton]="false"
  [hideSaveButton]="isExcludeBlocked"
  size="medium"
  position="center"
  (confirm)="onExcludeConfirm()">
  <div>
    <p class="dialog-intro">Are you sure you want to exclude the selected rows from this batch?</p>
    <p><strong>Selected records: {{ selectedRows.length }}</strong></p>
    <div class="comment-section">
      <label for="excludeComments">
        <strong>Remarks<span class="required-marker"> *</span></strong>
      </label>
      <textarea id="excludeComments" [(ngModel)]="comments" rows="4" class="dialog-textarea"
        placeholder="Please provide a reason for excluding these rows (required)">
      </textarea>
    </div>
  </div>
</ppl-popup-dialog>
